import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createRoomLobbySlice, type RoomLobbySlice } from '@/features/room-lobby';
import { createSessionSlice, type SessionSlice } from '@/features/session';

export type SessionStoreState = SessionSlice & RoomLobbySlice;

export const useSessionStore = create<SessionStoreState>()(
  subscribeWithSelector(
    immer((...a) => ({
      ...createSessionSlice(...a),
      ...createRoomLobbySlice(...a),
    })),
  ),
);
